'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'cloud-rainbow';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f73e';
var svgPathData = ['M48 376c0 30.9 25.1 56 56 56l304 0c30.9 0 56-25.1 56-56s-25.1-56-56-56c-13.3 0-24-10.7-24-24 0-30.9-25.1-56-56-56-15.6 0-29.6 6.3-39.8 16.6-5.5 5.6-13.5 8.1-21.2 6.7s-14.3-6.4-17.6-13.6c-11.4-24.7-36.4-41.8-65.4-41.8-39.8 0-72 32.2-72 72 0 4.5 .4 8.8 1.2 13 2.4 13-6.3 25.5-19.3 27.9-26.1 4.8-45.9 27.6-45.9 55.1zM330.3 144c20.2 .3 39.5 4.5 57 12 44.5-37.4 102-60 164.7-60 13.1 0 23.7 10.4 24 23.4l0-94.9c-.3 13-10.9 23.4-24 23.4-87.4 0-166.3 36.9-221.7 96zm99.8 39.4c11.9 10.8 22.1 23.5 30.1 37.5 26-18.2 57.6-28.9 91.8-28.9 13.1 0 23.7 10.4 24 23.4l0-94.9c-.3 13-10.9 23.4-24 23.4-45.5 0-87.6 14.6-121.9 39.4z', 'M330.3 144c55.5-59.1 134.3-96 221.7-96 13.3 0 24-10.7 24-24S565.3 0 552 0c-113.6 0-214.7 53.9-279.1 137.5 5.7 3.5 11.1 7.4 16.3 11.6 12.4-3.3 25.4-5 38.8-5 .8 0 1.5 0 2.3 0zm168 109.7c15.9-8.7 34.3-13.7 53.7-13.7 13.3 0 24-10.7 24-24s-10.7-24-24-24c-34.2 0-65.8 10.7-91.8 28.9 2.8 4.9 5.3 10 7.6 15.3 10.9 4.7 21.1 10.5 30.5 17.5zm-68.1-70.3c34.2-24.8 76.4-39.4 121.9-39.4 13.3 0 24-10.7 24-24s-10.7-24-24-24c-62.7 0-120.2 22.6-164.7 60 15.8 6.7 30.3 16 42.8 27.4zM112 280c0-39.8 32.2-72 72-72 28.9 0 53.9 17.1 65.4 41.8 3.3 7.1 9.9 12.2 17.6 13.6s15.7-1.2 21.2-6.7c10.2-10.3 24.2-16.6 39.8-16.6 30.9 0 56 25.1 56 56 0 13.3 10.7 24 24 24 30.9 0 56 25.1 56 56s-25.1 56-56 56l-304 0c-30.9 0-56-25.1-56-56 0-27.4 19.8-50.3 45.9-55.1 13-2.4 21.7-14.9 19.3-27.9-.8-4.2-1.2-8.5-1.2-13zm72-120c-66.3 0-120 53.7-120 120-37.6 15.7-64 52.7-64 96 0 57.4 46.6 104 104 104l304 0c57.4 0 104-46.6 104-104 0-50-35.3-91.7-82.3-101.7-10-47-51.7-82.3-101.7-82.3-18.3 0-35.4 4.7-50.3 13-22-27.4-55.7-45-93.7-45z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCloudRainbow = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;